import { render, staticRenderFns } from "./NextMoveFooter.vue?vue&type=template&id=456b2129&scoped=true&"
import script from "./NextMoveFooter.vue?vue&type=script&lang=ts&"
export * from "./NextMoveFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b2129",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
